// extracted by mini-css-extract-plugin
module.exports = {"legendImg":"Charts_legendImg__29jOd","legendBtn":"Charts_legendBtn__5r9xL","recordingSpan":"Charts_recordingSpan__1tdB0","blink-1":"Charts_blink-1__2Fiyf"};